import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import styles from "./index.module.scss";

type PropsType = {
  name: string;
  options: Array<{
    label: string;
    id: string;
    value: string;
    color?: "blue" | "red" | "green";
  }>;
  small?: boolean;
};
const ToggleSelection = ({ name, options, small }: PropsType) => {
  const { register, watch } = useFormContext();

  return (
    <fieldset className={styles.radioGroupFieldset}>
      <>
        {options.map((option) => (
          <label
            className={classNames(
              classNames,
              styles.radioInputLabel,
              { [styles.small]: small },
              { [styles.blue]: option.color === "blue" },
              { [styles.red]: option.color === "red" },
              { [styles.green]: option.color === "green" },
              {
                [styles.radioInputLabelSelected]: watch(name) === option.value,
              }
            )}
            htmlFor={option.id}
            key={option.id}
          >
            <input
              type="radio"
              className={classNames(classNames, styles.radioInput)}
              id={option.id}
              value={option.value}
              {...register(name, { required: true })}
            />

            <span
              className={classNames(styles.radioInputLabelText, {
                [styles.small]: small,
              })}
            >
              {option.label}
            </span>
          </label>
        ))}
      </>
      {/* {error && touched && <ErrorMessage field={field}>{error}</ErrorMessage>} */}
    </fieldset>
  );
};

export default ToggleSelection;
